
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "a25eb21b3f807c53e170166ed98f1acbf155756d",
  "nuxt": {
    "buildId": "7dd1d4a9-a538-473b-897a-fe015937c730"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
